import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "./IntegrationStore";
import { alert } from "../general/alertStore.js";
import IntegrationTrigger from "./IntegrationTrigger";

import axios from "../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import { Input, FormGroup, Label } from "../components/Modal";

class EdAdminIntegrationConfig {
    url?: string;
    apiKey?: string;


    constructor(config) {
        let _config = config || {};
        this.url = _config.url || "";
        this.apiKey = _config.apiKey || "";
    }
}

class EdAdminIntegration {
    config: EdAdminIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;
    priority: number;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;
        this.priority = integration.priority;

        this.config = new EdAdminIntegrationConfig(integration.config);
    }
}

interface EdAdminState {
    profiles: Array<EdAdminIntegration>;
    users: any;
    selectedProfile: EdAdminIntegration;
    selectedProfileId: string;
    syncResult: any;
}

interface EdAdminProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ImportEdAdminUsers extends Component<EdAdminProps, EdAdminState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new EdAdminIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 10; //EdAdmin
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    loadUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/GetEdAdminUsers`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
                this.setState({ syncResult: response.data });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ImportUsersFromEdAdmin`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
                this.setState({ syncResult: response.data });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/10?organizationId=${this.props.organization}`) //EdAdmin
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new EdAdminIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new EdAdminIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
      let priority = e.target.valueAsNumber;
      this.setState((prevState) => {
          prevState.selectedProfile.priority = priority;
          return prevState;
      });
  };

    handleEdAdminUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handleApiKeyChange = (e) => {
        let apiKey = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.apiKey = apiKey;
            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <h3 className="text-2xl font-semibold text-gray-900">EdAdmin Users</h3>

                <div className="space-y-6">
                    <FormGroup>
                        <Label htmlFor="profile">Profile</Label>
                        <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                            <option>Please Select</option>
                            {this.state.profiles.map((profile) => (
                                <option key={profile.integrationId} value={profile.integrationId}>
                                    {profile.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>

                        {this.state.selectedProfileId && (
                            <FormGroup>
                                <Label htmlFor="priority">Priority (lower first)</Label>
                                <Input type="number" id="priority" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                            </FormGroup>
                        )}

                        {!this.state.selectedProfileId && (
                            <div className="flex items-end justify-end">
                                <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>

                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="edAdminUrl">EdAdmin URL</Label>
                                    <Input type="text" id="edAdminUrl" value={this.state.selectedProfile.config.url} onChange={this.handleEdAdminUrlChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="apiKey">API Key</Label>
                                    <Input type="text" id="apiKey" value={this.state.selectedProfile.config.apiKey} onChange={this.handleApiKeyChange} />
                                </FormGroup>

                                <div className="flex items-end justify-end md:col-span-2">
                                    <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                        Save Profile
                                    </button>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2">
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.loadUsers}>
                                    Load
                                </button>
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.syncUsers}>
                                    Sync
                                </button>
                            </div>

                            {this.state.syncResult && (
                                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                                    <a href={`/hangfire/jobs/details/${this.state.syncResult}`} className="text-blue-600 hover:text-blue-800 underline">
                                        Background Job Created
                                    </a>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
